import styled from '@emotion/styled';
import { useTranslate } from '@tolgee/react';
import { Button, Modal } from 'antd';
import useChannelMateriel from 'hooks/useChannelMateriel';
import React, { useMemo } from 'react';
import { useBusinessDocument } from 'hooks/useBusinessDocument';
const LinkButton = styled(Button)`
  padding: 0;
`;
const Frame = styled.div`
  padding: 0;
  height: 65vh;
  > iframe {
    width: 100%;
    height: 100%;
    border: none;
  }
`;
export const ServiceAgreementLink = React.memo(() => {
  const { t } = useTranslate();
  const { config } = useChannelMateriel();
  const { serviceAgreement } = useBusinessDocument();

  const link = useMemo(() => {
    if (config?.serviceDocLink) return config?.serviceDocLink;

    return serviceAgreement;
  }, [config?.serviceDocLink, serviceAgreement]);

  return (
    <LinkButton
      size="small"
      type="link"
      onClick={() => {
        Modal.confirm({
          title: t('ViewStartups.Service.Agreement'),
          width: '95vw',
          icon: null,
          content: (
            <Frame>
              <iframe title={t('ViewStartups.Service.Agreement')} src={link} />
            </Frame>
          ),
        });
      }}
    >
      {t('ViewStartups.Service.Agreement')}
    </LinkButton>
  );
});

export const PrivacyPolicyLink = React.memo(() => {
  const { t } = useTranslate();
  const { privacyPolicy } = useBusinessDocument();

  return (
    <LinkButton
      size="small"
      onClick={() => {
        Modal.confirm({
          title: t('ViewStartups.Privacy.Policy'),
          width: '95vw',
          icon: null,
          content: (
            <Frame>
              <iframe title={t('ViewStartups.Privacy.Policy')} src={privacyPolicy} />
            </Frame>
          ),
        });
      }}
      type="link"
    >
      {t('ViewStartups.Privacy.Policy')}
    </LinkButton>
  );
});

export const SoftWareLicenseLink = React.memo(() => {
  const { t } = useTranslate();
  return (
    <LinkButton
      size="small"
      onClick={() => {
        Modal.confirm({
          title: t('ViewStartups.Software.License'),
          width: '95vw',
          icon: null,
          content: (
            <Frame>
              <iframe
                title={t('ViewStartups.Software.License')}
                src={`${process.env.PUBLIC_URL}/license.htm`}
              />
            </Frame>
          ),
        });
      }}
      type="link"
    >
      {t('ViewStartups.Software.License')}
    </LinkButton>
  );
});
